import {Component} from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { finalize } from 'rxjs';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';

import { SettingFormComponent } from '../../forms/setting-form/setting-form.component';
import { MdbButtonComponent } from '../../utils/mdb-button/mdb-button.component';
import { HttpErrorsService } from '../../../services/utils/http-errors.service';
import { SettingService } from '../../../services/resources/setting.service';
import { SettingModel } from '../../../models/resources/setting.model';
import { CustomNotificationService } from '../../../services/utils/custom-notification.service';
import { SafeUpdateService } from '../../../services/utils/safe-update.service';
import { AConcreteResource } from '../../AConcreteResource';
import {SpinnerComponent} from "../../utils/spinner/spinner.component";

@Component({
  selector: 'app-settings',
  standalone: true,
  imports: [
    SettingFormComponent,
    ReactiveFormsModule,
    MdbButtonComponent,
    SpinnerComponent,
  ],
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.scss',
})
export class SettingsComponent extends AConcreteResource<SettingModel>{
  loading: boolean = false;
  formGroup: FormGroup | undefined;

  constructor(
    router: Router,
    private settingService: SettingService,
    private httpErrorsService: HttpErrorsService,
    private notificationService: CustomNotificationService,
    private safeUpdateService: SafeUpdateService
  ) {
    super(router, settingService);
  }

  ngOnInit(): void {
    this.settingService.getOne(1).subscribe({
      next: (setting: SettingModel) => {
        this.settingService.addConcreteModel(setting);
      },
      error: (e) => this.httpErrorsService.handleError(e),
    });
  }

  saveNewSettings(serverResource: any = null, overrideValues: { [key: string]: any } = {}) {
    this.formGroup!.markAllAsTouched();

    if (this.formGroup!.invalid) return;

    this.loading = true;

    let resource = {
      ...this.formGroup!.value,
    roOriginLatitude: String(this.formGroup!.value.roOriginLatitude?.toString().replace(',', '.')),
      roOriginLongitude: String(this.formGroup!.value.roOriginLongitude?.toString().replace(',', '.')),
    };

    resource.updatedAt = this.model()!.updatedAt;

    if (serverResource)
      resource = this.safeUpdateService.handleResource(serverResource, resource, overrideValues);

    this.settingService
      .update(this.model()!.id, resource)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: () => {
          this.notificationService.success('CHANGES_SUCCESSFULLY_SAVED')
        },
        error: (e: HttpErrorResponse) => {
        this.httpErrorsService.handleError(e, (newServerResource, newOverrideValues) => {
          this.saveNewSettings(newServerResource, newOverrideValues);
        });
        },
      });
  }

  getValueOf(controlName: string) {
    return this.formGroup?.get(controlName)?.value;
  }
}
